import { RestLink } from 'apollo-link-rest';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import camelCase from 'camelcase';
import { env } from '../../constants/env';

import urlJoin from 'url-join';
import { gql } from 'graphql.macro';

const GRAPHQL_ENDPOINT = '/api/agent_services/graphql';
const REST_ENDPOINT = '/api/agent_services/one_inc_4/';
const REST_ENDPOINT_VARYS = '/v1/portal/';

const httpLink = createHttpLink({
  uri: urlJoin(env.reznorHostname, GRAPHQL_ENDPOINT),
});

const restLink = new RestLink({
  uri: '',
  endpoints: {
    oneInc: urlJoin(env.reznorHostname, REST_ENDPOINT),
    varys: urlJoin(env.varysHostname, REST_ENDPOINT_VARYS),
  },
  fieldNameNormalizer: key => camelCase(key),
});

export const buildApolloClient = (token: string) => {
  const setAuthorizationLink = setContext(() => ({
    headers: { Authorization: `Bearer ${token}` },
  }));

  return new ApolloClient({
    link: ApolloLink.from([
      setAuthorizationLink.concat(restLink),
      setAuthorizationLink.concat(httpLink),
    ]),
    cache: new InMemoryCache(),
    typeDefs: gql`
      enum Resource {
        policy
      }
    `,
  });
};
